
define('tpl!taoQtiItem/qtiCreator/widgets/static/table/components/tableActions', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"table-tlb table-col-tlb\">\n    <div class=\"rgt tlb-button\" title=\"Insert Row\" data-role=\"insertRow\">\n        <span class=\"icon-row\"></span>\n    </div>\n    <div class=\"rgt tlb-button\" title=\"Insert Column\" data-role=\"insertCol\">\n        <span class=\"icon-column\"></span>\n    </div>\n    <div class=\"rgt tlb-button\" title=\"";
  if (helper = helpers.deleteTitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.deleteTitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-role=\"colRowDelete\">\n        <span class=\"icon-bin\"></span>\n    </div>\n</div>\n";
  return buffer;
  });
});

